import { create } from "zustand"
import { ProductType } from "./_models";
import { isValidString } from "../../../components/helpers";

interface ProductTypesListingState {
  productTypes: Array<ProductType>
  setProductTypes: (productTypes: Array<ProductType>) => void  
  getCategoryIdByString: (id: number, name: string) => number
}

export const useProductTypesListingState = create<ProductTypesListingState>()((set, get) => ({
  productTypes: [],
  setProductTypes: (productTypes: Array<ProductType>) => set({productTypes}),
  getCategoryIdByString: (id: number, name: string) => {
    // 1. Guard clause for invalid inputs
    if (!(id > 0 && isValidString(name))) return 0;

    // 2. Find product using native Array.prototype.find
    const product = get().productTypes.find((p) => p.id === id && !p?.deleted);
    if (!product?.productCategoriesSet) return 0;

    // 3. Find category inside product
    const category = product.productCategoriesSet.find(
      (cat) => cat.name === name && !cat?.deleted
    );

    return category?.id ?? 0;
  },

}));